import { render } from "./breadcrumb-header.vue?vue&type=template&id=622b06ca"
import script from "./breadcrumb-header.vue?vue&type=script&lang=js"
export * from "./breadcrumb-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__